import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Book from 'assets/icons/Book';
import Lamp from 'assets/icons/Lamp';
import { Timeline } from 'components/Timeline/Timeline';
import { TimelineItemProps } from 'components/Timeline/__types';
import { RootState } from 'store/reducer';
import { EscolaEditTabs } from '../../__enum';
import Informacoes from '../../../Informacoes';
import { TogglePrograma } from '../TogglePrograma';
import { getProgramaInfo, setCurrentTab } from 'store/modules/EscolasActions';
import { useParams } from 'react-router-dom';

export const EscolaSteps = () => {
  const { id, tab } = useParams() as { tab: any, id: string };
  const currentIndex = useSelector(
    (state: RootState) => state.escolas.currentTab
  );
  const dispatch = useDispatch();

  const items: TimelineItemProps[] = [
    { id: EscolaEditTabs.Informacoes, icon: <Book />, label: 'Informações' },
    { id: EscolaEditTabs.ProgramasEducacionais, icon: <Lamp />, label: 'Programas educacionais' },
  ];

  useEffect(() => {
    if (tab) {
      dispatch(setCurrentTab(tab));
    }
  }, [tab, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(getProgramaInfo(id));
    }
  }, [dispatch, id]);

  const renderForm = useCallback((index: EscolaEditTabs) => {
    switch (index) {
      case EscolaEditTabs.Informacoes:
        return <Informacoes />;
      case EscolaEditTabs.ProgramasEducacionais:
        return <TogglePrograma />;
      default:
        return null;
    }
  }, []);

  return (
    <Timeline
      items={items}
      renderForm={renderForm}
      currentTab={currentIndex}
    />
  );
};
